/**
 * Destino externo de renegociação de débitos (sub-marca regularize-aí).
 * Domínio próprio, fora da SPA — sempre linkar com `<a target="_blank">`,
 * nunca com o `<Link>` do react-router.
 */
export const REGULARIZE_AI_URL = 'https://thopen.regularize-ai.com.br/';
export const REGULARIZE_AI_COMO_FUNCIONA_URL = 'https://thopen.regularize-ai.com.br/?nav=1#ra-como-funciona';

/**
 * Registra o clique de saída no GTM (carregado em `index.html`).
 * `origem` identifica de qual bloco da LP partiu o clique.
 */
export function trackRegularizeAiClick(linkText: string, origem: string): void {
  window.dataLayer?.push({
    event: 'outbound_regularize_ai',
    link_text: linkText,
    link_origem: origem
  });
}
